/**
 * Beat-the-Pro opponent nano-id auth. Minted per hole-competition opponent
 * (the pro), sent in SMS, used on the public `/b/:opponentKey/*` routes.
 *
 * Tab-local for the same reason as the player key — see the note in
 * `auth-state.ts`. localStorage is shared across tabs, so a second pro's link
 * would otherwise make every open tab authenticate as that pro, and bets are
 * written from this header.
 */

const OPPONENT_STORAGE_KEY = 'polf-opponent-key'

/** The key THIS tab authenticates as. Set by OpponentKeyLoader from the URL. */
let activeOpponentKey: string | null = null

/** What the Apollo `opponent-key` link sends. Never another tab's key. */
export const getActiveOpponentKey = (): string | null => activeOpponentKey

/** Sets the key for this tab; the stored copy is last-used only, never auth. */
export const setOpponentKey = (key: string): void => {
  activeOpponentKey = key
  if (typeof window === 'undefined') return
  window.localStorage.setItem(OPPONENT_STORAGE_KEY, key)
}
